import Cookies from 'js-cookie'
import { globalCommon } from './constant'

const { TOKEN_KEY, EXPIRES_KEY, TOKEN_VALIDE_LIMIT } = globalCommon

export const setToken = (token, expires) => {
	let expiresTime = Date.now() + expires * 1000
	Cookies.set(TOKEN_KEY, token, { expires: expiresTime })
	Cookies.set(EXPIRES_KEY, expiresTime, { expires: expiresTime })
}

export const getToken = () => {
	const token = Cookies.get(TOKEN_KEY)
	if (token) return token
	else return false
}

export const removeToken = () => {
	Cookies.remove(TOKEN_KEY)
	Cookies.remove(EXPIRES_KEY)
}

export const localSave = (key, value) => {
	localStorage.setItem(key, value)
}

export const localRead = (key) => {
	return localStorage.getItem(key) || ''
}

export const getTokenExpires = () => {
	let expires = Cookies.get(EXPIRES_KEY)
	if (expires) return expires
	else return false
}

export const checkTokenValidity = () => {
	let now = Date.now()
	let expires = getTokenExpires()
	return expires - now < TOKEN_VALIDE_LIMIT
}

export const getParams = (url) => {
	const keyValueArr = url.split('?')[1].split('&')
	let paramObj = {}
	keyValueArr.forEach((item) => {
		const keyValue = item.split('=')
		paramObj[keyValue[0]] = keyValue[1]
	})
	return paramObj
}

export const requireParam = (obj) => {
	var rangeArr = [],
		param = ''
	if (obj && typeof obj === 'object') {
		if (rangeArr.length == 0) {
			rangeArr.push('?')
		}
		for (let i in obj) {
			// eslint-disable-next-line no-prototype-builtins
			if (obj.hasOwnProperty(i)) {
				if (obj[i] !== '') {
					rangeArr.push(i)
					rangeArr.push('=')
					rangeArr.push(obj[i])
					rangeArr.push('&')
				}
			}
		}
		param = rangeArr.join('').replace(/&$/, '')
		return param
	}
}
